// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.link {

    margin-left: auto;

    margin-right: auto;

    margin-top: 0.5rem;

    width: 100%;

    padding-top: 0.5rem;

    padding-bottom: 0.5rem;

    padding-left: 2rem;

    font-size: 1.125rem;

    line-height: 1.75rem;

    font-weight: 300;

    text-transform: uppercase;

    --tw-text-opacity: 1;

    color: rgb(255 255 255 / var(--tw-text-opacity))
}

.active-link {

    border-left-width: 8px;

    --tw-border-opacity: 1;

    border-left-color: rgb(239 68 68 / var(--tw-border-opacity));

    background-color: rgb(54 54 54 / 0.8);

    padding-left: 1.5rem;

    font-weight: 600;

    --tw-text-opacity: 1;

    color: rgb(239 68 68 / var(--tw-text-opacity))
}
`, "",{"version":3,"sources":["webpack://./src/components/SideNavItem.css"],"names":[],"mappings":"AACE;;IAAA,iBAA4E;;IAA5E,kBAA4E;;IAA5E,kBAA4E;;IAA5E,WAA4E;;IAA5E,mBAA4E;;IAA5E,sBAA4E;;IAA5E,kBAA4E;;IAA5E,mBAA4E;;IAA5E,oBAA4E;;IAA5E,gBAA4E;;IAA5E,yBAA4E;;IAA5E,oBAA4E;;IAA5E;AAA4E;;AAI5E;;IAAA,sBAAkF;;IAAlF,sBAAkF;;IAAlF,4DAAkF;;IAAlF,qCAAkF;;IAAlF,oBAAkF;;IAAlF,gBAAkF;;IAAlF,oBAAkF;;IAAlF;AAAkF","sourcesContent":[".link {\n  @apply text-white uppercase text-lg w-full mx-auto mt-2 pl-8 py-2 font-light;\n}\n\n.active-link {\n  @apply text-red-500 border-l-8 border-l-red-500 pl-6 bg-[#363636]/80 font-semibold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
